<template>
  <div id="formulario-edit-info">
  
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
    <vx-card>
         <div class="vx-row mb-4">
            <div class="vx-col lg:w-1/2 md:w-full sm:w-full w-full items-center justify-center flex">
                    <vs-radio v-model="data_local.tipo" vs-value="ENTRADA"> <h2> ENTRADA </h2></vs-radio>  <span class="ml-4"> ou </span>
                    <vs-radio v-model="data_local.tipo" vs-value="SAIDA" color="success" class="ml-4"><h2>SAÍDA</h2></vs-radio>
                    <vs-button class="ml-auto" color="primary" @click="routeHistorico">HISTÓRICO</vs-button>             
            </div>
         </div>
         <div class="vx-row mb-4">
            <div class="vx-col lg:w-1/2 md:w-full sm:w-full w-full">
                <h5 style="text-transform: uppercase;" class="w-full text-center">{{$t("TelaReceitas_lVeiculo")}}</h5>
                 <vx-input-group>
                    <vs-input size="huge" class="w-full" v-model="placaParaPesquisar" v-mask="['AAA-#X##', 'AAA-#X##']" icon="calendar_view_day" placeholder="Digite a placa" @keyup.enter.native="localizarVeiculo" @input="alterouVeiculo"/>
                    <template slot="append">
                        <div class="append-text btn-addon">                                
                            <vs-button color="primary" size="large" icon-pack="feather" @click="localizarVeiculo" icon="icon-search" v-if="placaParaPesquisar && placaParaPesquisar.length >= 8"></vs-button>                  
                        </div>
                    </template>
                </vx-input-group> 
            </div>
         </div>

        <div v-if="exibirCampos">
            <h5 v-if="isNovoVeiculo" class="w-full text-center text-primary" style="text-transform: uppercase;"> Novo Veículo </h5>
            <h5 v-if="!isNovoVeiculo" class="w-full text-center text-success" style="text-transform: uppercase;"> Veículo Encontrado </h5>
            <div style="background-color: #F7F7F7; padding-top: 12px; padding-left: 10px; padding-right: 10px; padding-bottom: 6px; border-radius:10px; border: 1px black solid;">
                <div class="vx-row">
                    <div class="vx-col sm:w-1/3 w-full mb-2">                                  
                        <h5 style="text-transform: uppercase;" >{{$t('TelaVeiculoExterno_marca')}}</h5> 
                        <v-select                       
                            label="marca"        
                            :reduce="m => m.marca"                
                            :options="listaMarcaVeiculos" 
                            :disabled="isVeiculoCadastrado"
                            v-model="dadosVeiculo.marca"                      
                            class="w-full h2">
                        </v-select> 
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/3 w-full mb-2">                  
                        <h5 style="text-transform: uppercase;" >{{$t('TelaVeiculoExterno_modelo')}}</h5> 
                        <v-select                       
                            label="modelo"        
                            :reduce="m => m.modelo"                
                            :options="listaModeloVeiculos" 
                            :disabled="isVeiculoCadastrado"
                            v-model="dadosVeiculo.modelo"                      
                            class="w-full h2">
                        </v-select> 
                    </div> 
                    <div class="vx-col sm:w-1/3 w-full mb-2" v-if="dadosVeiculo.modelo === 'Outro'">                
                        <h5 style="text-transform: uppercase;" >{{$t('TelaAlterarVeiculo_lModeloOutro')}}</h5> 
                        <vs-input class="w-full h2" v-model="dadosVeiculo.modeloOutro" icon="label" :readonly="isVeiculoCadastrado"/>
                    </div>               
                </div>
                <div class="vx-row mb-4" v-if="isNovoVeiculo">
                    <div class="vx-col w-1/2">                
                        <h5 style="text-transform: uppercase;" >{{$t('TelaVeiculoExterno_cor')}}</h5> 
                        <vs-input size="large" class="w-full h2" v-model="dadosVeiculo.cor" icon="color_lens"  maxlength="45" :readonly="isVeiculoCadastrado"/>
                    </div>     
                    <div class="vx-col w-1/2">                
                        <h5 style="text-transform: uppercase;" >{{$t('TelaVeiculoExterno_placa')}}</h5> 
                        <vs-input size="large" class="w-full" v-model="dadosVeiculo.placa" v-mask="['AAA-#X##', 'AAA-#X##']" icon="calendar_view_day" readonly="true"/>
                    </div> 
                </div>
            </div>
            <div class="vx-row mb-4">           
                <div class="vx-col lg:w-1/2 md:w-full sm:w-full w-full mt-4">
                    <h5 style="text-transform: uppercase;" class="w-full text-center">Motorista</h5>
                    <v-select                                                           
                        label="nome"
                        :options="listaMotoristas"                   
                        v-model="data_local.motorista"       
                        class="v-select w-full h3"
                        v-if="data_local.veiculo && data_local.veiculo.idVeiculo">
                        <template #option="{  nome, cpf, codigoChaveiro  }">
                            <small><strong> {{nome}} </strong>  
                            <em> - {{cpf}}</em> <em v-if="codigoChaveiro"> - {{codigoChaveiro}} </em></small>
                        </template>
                        <template #selected-option="{ nome  }">                          
                            <small>{{nome}}</small>
                        </template>
                        <template #no-options="">
                            {{ $t('NenhumMotoristaEncontrado') }}
                        </template>
                    </v-select> 
                     <vs-input class="w-full" size="large" v-model="data_local.nomeMotoristaExterno" icon="people" v-if="!data_local.veiculo || !data_local.veiculo.idVeiculo"/>
                </div>                                                  
            </div>
            <div class="vx-row mb-4">
                <div class="vx-col lg:w-1/4 w-full">
                    <h5 style="text-transform: uppercase;" class="w-full text-center">Data</h5>
                    <flat-pickr v-model="data_local.data" class="w-full opacity-75" :config="configDatePicker" />
                </div>  
            </div>
            <div class="vx-row mb-4">
                <div class="vx-col lg:w-1/4 w-full">
                    <h5 style="text-transform: uppercase;" class="w-full text-center">Hora</h5>
                    <vx-input-group>
                        <vs-input size="huge" class="w-full" inputmode="numeric" v-model="data_local.hora" v-mask="['##:##']" icon="calendar_view_day"/>
                        <template slot="append">
                            <div class="append-text btn-addon">                                
                                <vs-button color="primary" icon-pack="feather" @click="atualizarHora" icon="icon-refresh-cw" class=""></vs-button>                  
                            </div>
                        </template>
                    </vx-input-group> 
                </div>  
            </div>
            <div class="vx-row mb-4">
                <div class="vx-col lg:w-1/4 w-full">
                    <h5 style="text-transform: uppercase;" class="w-full text-center">Odômetro</h5>
                    <vue-autonumeric inputmode="numeric" style="font-size:36px !important;" class="vs-inputx vs-input--input normal hasValue w-full" v-model="data_local.odometroEmKMInformado" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'0', emptyInputBehavior: 'null' }]"></vue-autonumeric>
                </div>     
            </div>
            <div class="vx-row mb-4">
                <div class="vx-col lg:w-1/4 w-full">
                    <h5 style="text-transform: uppercase;" class="w-full text-center">Horímetro</h5>                
                    <vue-autonumeric inputmode="numeric" style="font-size:36px !important;" class="vs-inputx vs-input--input normal hasValue w-full" v-model="data_local.horimetroInformado" :options="[{ digitGroupSeparator: '.', decimalCharacter: ',', minimumValue: '0', decimalPlaces:'0', emptyInputBehavior: 'null' }]"></vue-autonumeric>
                </div>            
            </div>   
            <div class="vx-row mb-4">
                <div class="vx-col w-full">
                    <h5 style="text-transform: uppercase;" class="w-full text-center">Observação</h5>                
                    <vs-textarea counter="1024" class="w-full" v-model="data_local.observacao" name="observacao" maxlength="1024"/>                
                </div>
            </div>                   
        </div>
        <div class="vx-row">
            <div class="vx-col w-full flex">                    
                <vs-button class="mr-auto mt-2" @click="gravar"  color="success" v-if="exibirCampos">{{ $t('Btn_Gravar') }}</vs-button>                
                <vs-button class="ml-auto mt-2" type="border" color="dark" @click="sair" v-if="isExibirSair">SAIR</vs-button>             
            </div>
        </div>
    </vx-card>  
  </div>
</template>

<script>
import axios from "@/axios.js"
import generico from '@/generico.js'
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Portuguese as PortugueseLocale} from 'flatpickr/dist/l10n/pt.js';
//import {english as EnglishLocale} from 'flatpickr/dist/l10n/default.js'
//import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es.js'
//import generico from '@/generico.js'
import 'vue-select/dist/vue-select.css';

const URL_SERVLET = "/rest/ControlePortaria/";

export default { 
  components: {  
    flatPickr,
    VueAutonumeric
  }, 
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
            return { veiculo:{ idVeiculo:null, placa: null }, veiculoExterno:{id: null, placa: null}, motorista :{id: null, nome: null}, data: null,  hora: null,
            odometroEmKMInformado: null, horimetroInformado: null, observacao: null, tipo: null, sairDaFilaEntrada: false, nomeMotoristaExterno: null }
       }
    },
  },
  data() {
    return {    
        exibirCampos: false,         
        placaParaPesquisar: null, 
        configDatePicker: {          
          altInput: true,
            altFormat: "d-m-Y",
            dateFormat: "Y-m-d", 
          altInputClass: "vs-inputx vs-input--input normal text-center huge",
          locale: PortugueseLocale,
          enableTime: false
        },        
        listaMotoristas: [],   
        listaVeiculos: [],            
        listaVeiculosExternos: [],            
        listaMarcaVeiculos: [],
        listaModeloVeiculos: [], 
        errorsValidacao: [],  
        data_local: JSON.parse(JSON.stringify(this.registroOriginal)),
        dadosVeiculo: {marca:null, modelo:null, modeloOutro:null, cor: null,placa : null}
    }
  },    
  mounted() {      
    this.fetchListaMarcaVeiculos();
    this.fetchListaModeloVeiculos();
    this.fetchVeiculos();  
    this.fetchMotoristas();         
    this.fetchVeiculosExternos();
            
    var agora = new Date();
    this.data_local.data = agora.getFullYear() + "-" + generico.zeroPad((agora.getMonth() + 1), 2) + "-" + generico.zeroPad(agora.getDate(), 2);
    this.data_local.hora = generico.zeroPad(agora.getHours(), 2) + ":" + generico.zeroPad(agora.getMinutes(), 2);
       
  },
  computed: {
    isVeiculoCadastrado(){                
        return !this.isNovoVeiculo;
    },
    isNovoVeiculo(){        
        if (!this.data_local.veiculo.idVeiculo && !this.data_local.veiculoExterno.id) {
            return true;
        }
        return false;
    },         
    isDeletable() {
       return this.data_local != null && this.data_local.hasOwnProperty("id") && this.temCapacidadeMaster;
    },
    isUpdatable() {
       return (this.data_local != null && !this.data_local.hasOwnProperty("id") ) || (this.data_local != null && this.data_local.hasOwnProperty("id"));
    },    
    temCapacidadeMaster(){
      if (this.isAcessoMaster) {
        return true;
      } else if (this.isAcessoGrupo) {
        return this.$store.state.AppActiveUser.capacidadeMaster;
      }
      return false;
    },
    isAcessoMaster() {
        return this.$store.getters.isAcessoMaster;
    },
    isAcessoIndividual(){
        return this.$store.getters.isAcessoIndividual;
    },
    isAcessoGrupo(){
        return this.$store.getters.isAcessoGrupo;
    },  
    isExibirVoltar(){
        if (this.$route.meta.hasOwnProperty('origem') && this.$route.meta.origem === 'tela-solo') {
            return false;
        }
        return true;
    },
    isExibirSair(){
        if (this.$route.meta.hasOwnProperty('origem') && this.$route.meta.origem === 'tela-solo') {
            return true;
        }
        return false;
    }
  },
  methods: { 
    limparCampos() {
        this.placaParaPesquisar = null;
        this.dadosVeiculo.marca = null;
        this.dadosVeiculo.modelo = null;
        this.dadosVeiculo.modeloOutro = null;
        this.dadosVeiculo.cor = null;
        this.dadosVeiculo.placa = null;
        this.exibirCampos = false; 
        this.data_local ={ veiculo:{ idVeiculo:null, placa: null }, veiculoExterno:{id: null, placa: null}, motorista :{id: null, nome: null}, data: null,  hora: null,
            odometroEmKMInformado: null, horimetroInformado: null, observacao: null, tipo: null, sairDaFilaEntrada: false, nomeMotoristaExterno: null };
    },
    alterouVeiculo() {
        this.dadosVeiculo.marca = null;
        this.dadosVeiculo.modelo = null;
        this.dadosVeiculo.modeloOutro = null;
        this.dadosVeiculo.cor = null;
        this.dadosVeiculo.placa = null;
        this.exibirCampos = false; 
        this.data_local.veiculo = {idVeiculo: null, placa: null};
        this.data_local.veiculoExterno = {id: null, placa: null};
    } ,
    localizarVeiculo() {   
        
        if (this.placaParaPesquisar.length < 8) {
            this.$vs.notify({time:8000, title: "Atenção",  text: "Informe a placa completa para pesquisar", iconPack: 'feather', icon: 'icon-alert-circle', color: 'danger'});
            return;
        }

        let veiculoEncontrado = this.localizarVeiculoInterno();
        if (!veiculoEncontrado) {
            veiculoEncontrado = this.localizarVeiculoExterno();
            if (veiculoEncontrado) {
                this.data_local.veiculoExterno = veiculoEncontrado;
                this.data_local.veiculo = {idVeiculo: null, placa: null};
                this.data_local.nomeMotoristaExterno = this.data_local.veiculoExterno.nomeMotorista;
            }
        } else {
            this.data_local.veiculo = veiculoEncontrado;
            this.data_local.veiculoExterno = {id: null, placa: null};
            if (veiculoEncontrado.hasOwnProperty('idMotoristaVeiculo')) {
                this.data_local.motorista = {id: veiculoEncontrado.idMotoristaVeiculo, nome: veiculoEncontrado.condutor};
            }
        }

        if (veiculoEncontrado) {            
            this.dadosVeiculo.marca = veiculoEncontrado.marca;
            this.dadosVeiculo.modelo = veiculoEncontrado.modelo;
            this.dadosVeiculo.modeloOutro = veiculoEncontrado.modeloOutro;
            this.dadosVeiculo.cor = veiculoEncontrado.cor;
            this.dadosVeiculo.placa = veiculoEncontrado.placa;
            this.exibirCampos = true;            
        } else {
            this.dadosVeiculo.marca = null;
            this.dadosVeiculo.modelo = null;
            this.dadosVeiculo.modeloOutro = null;
            this.dadosVeiculo.cor = null;
            this.dadosVeiculo.placa = null;
            this.exibirCampos = false; 
            this.$vs.dialog({ type: 'confirm', color: 'warning', title: `Atenção`,
                text: 'Veículo não cadastrado. Deseja cadastrar ?', acceptText: 'SIM', cancelText: 'NÃO',
                accept: this.exibirCamposCadastroVeiculoExterno });                          
        }        
    },
    exibirCamposCadastroVeiculoExterno(){
        this.exibirCampos = true; 
        this.data_local.veiculo = { idVeiculo:null, placa: null };
        this.data_local.veiculoExterno = {id: null, placa: null};        
        this.dadosVeiculo.placa = this.placaParaPesquisar;
    },
    localizarVeiculoInterno() {      
      let varTermoPesquisa = this.placaParaPesquisar.toUpperCase();
      let veiculoEncontrado = this.listaVeiculos.filter(function (veiculo) {
              return (veiculo.placa.toUpperCase().indexOf(varTermoPesquisa) != -1 ) ;
      });
      
      if (veiculoEncontrado)  {
        this.data_local.veiculo = veiculoEncontrado[0];
        return veiculoEncontrado[0];
      }

      return null;      
    }, 
    localizarVeiculoExterno() {      
      let varTermoPesquisa = this.placaParaPesquisar.toUpperCase();
      let veiculoEncontrado = this.listaVeiculosExternos.filter(function (veiculo) {
              return (veiculo.placa.toUpperCase().indexOf(varTermoPesquisa) != -1);
      });
      
      if (veiculoEncontrado)  {
        this.data_local.veiculoExterno = veiculoEncontrado[0];
        return veiculoEncontrado[0];
      }

      return null;      
    }, 
    atualizarHora(){
        var agora = new Date();                            
        this.data_local.hora = generico.zeroPad(agora.getHours(), 2) + ":" + generico.zeroPad(agora.getMinutes(), 2);
    },
    fetchListaMarcaVeiculos() {
      const params = new URLSearchParams();
      params.append('pagina', -1);
      axios.post("/rest/MarcaVeiculo/Listar", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {                    
          this.listaMarcaVeiculos = response.data.Resultado.lista.item;
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("Error Fech Lista Marcas Veiculos " + error);        
      })      
    },  
    fetchListaModeloVeiculos() {
      const params = new URLSearchParams();
      params.append('pagina', -1);
      axios.post("/rest/ModeloVeiculo/Listar", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {                    
          this.listaModeloVeiculos = response.data.Resultado.lista.item;
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("Error Fech Lista Modelo Veiculos " + error);        
      })      
    },
    fetchVeiculos() {    
      const params = new URLSearchParams();
      params.append('outputFormat', 'JSON');
      params.append('idCliente', this.$store.state.AppActiveUser.id);
      params.append('funcionalidade', 'CONTROLE_ENTRADA_SAIDA_MANUAL');

      axios.get("/RecuperarVeiculosAtivosCliente", {
              params, 
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
        if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {            
            this.$router.push({ path: '/controle-portaria' });
        } else {
            this.listaVeiculos = response.data;                           
        }
        this.$vs.loading.close();
      })
      .catch((error) => { 
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchVeiculos - " + error); 
          this.$vs.loading.close();
      })       
    },    
    fetchVeiculosExternos() { 
      this.$vs.loading();     
      this.currentPage = 1;
      const params = new URLSearchParams();      
      params.append('idCliente', this.$store.state.AppActiveUser.id);      
      params.append('idEmpresa', this.$store.state.AppActiveUser.idEmpresa);   
      params.append('pagina', -1);
      params.append('ativo', true);      
      params.append('tipo', 'portaria');      

      axios.post("/rest/VeiculoExterno/Listar", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close();
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/controle-portaria' });
          } else {              
              if (response.data.Resultado.quantidade > 1) {
                  this.listaVeiculosExternos = response.data.Resultado.lista.item;
              } else if (response.data.Resultado.quantidade === 1) {
                  this.listaVeiculosExternos = [];
                  this.listaVeiculosExternos.push(response.data.Resultado.lista.item);
              } else {
                  this.listaVeiculosExternos = [];
              }
          }
      })
      .catch((error) => { 
          this.$vs.loading.close();
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchVeiculosExternos - " + error); 
      })    
                        
    },
    fetchMotoristas() {      
          const params = new URLSearchParams();
          params.append('method', 'FindAll');
          params.append('orderDirection', 'ASC');
          params.append('outputFormat', 'JSON');
          params.append('idCliente', this.$store.state.AppActiveUser.id);
          params.append('motoristaAtivo', true); 
          
          axios.post("/MotoristasRestServlet", params, 
                  { credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
          .then((response) => {
              if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) { // Efetuar logoff                    
                  this.$router.push({ path: '/controle-portaria' })
              } else {
                  this.listaMotoristas = response.data;                       
              }
          })
          .catch((error) => { 
              /* eslint-disable no-console */   console.log("EFETUAR LOGOFF! - " + error);
          })                  
    },    
    pesquisarVeiculo(options, varTermoPesquisa) {
      
      varTermoPesquisa = varTermoPesquisa.toUpperCase();
      return options.filter(function (veiculo) {
              return (veiculo.marca.toUpperCase().indexOf(varTermoPesquisa) != -1  || veiculo.modelo.toUpperCase().indexOf(varTermoPesquisa) != -1 || 
              veiculo.placa.toUpperCase().indexOf(varTermoPesquisa) != -1 || veiculo.condutor.toUpperCase().indexOf(varTermoPesquisa) != -1 || 
              (veiculo.labelVeiculo && veiculo.labelVeiculo.toUpperCase().indexOf(varTermoPesquisa) != -1)
              ) ;
      })
    },     
    gravar() {        
        if (this.formularioValido()) { 
            this.$vs.loading();
            const params = new URLSearchParams();      
            params.append('login', this.$store.state.dadosRelogin.relogin);
            params.append('senha', this.$store.state.dadosRelogin.resenha);  
            params.append('cliente.id', this.$store.state.AppActiveUser.id);
            
            if (this.data_local.veiculo.idVeiculo) {
                params.append('veiculo.id', this.data_local.veiculo.idVeiculo);   
                if (this.data_local.motorista && this.data_local.motorista.id) {
                    params.append("motorista.id", this.data_local.motorista.id);
                }  
            } else  if (this.data_local.veiculoExterno.id){
                params.append('veiculoExterno.id', this.data_local.veiculoExterno.id);   
                params.append("nomeMotoristaExterno", this.data_local.nomeMotoristaExterno);
            } else {
                params.append('veiculoExterno.marca', this.dadosVeiculo.marca);   
                params.append('veiculoExterno.modelo', this.dadosVeiculo.modelo);   
                if (this.dadosVeiculo.modeloOutro) {
                    params.append('veiculoExterno.modeloOutro', this.dadosVeiculo.modeloOutro);   
                }
                
                params.append('veiculoExterno.placa', this.dadosVeiculo.placa);      
                params.append('veiculoExterno.cor', this.dadosVeiculo.cor);      
                params.append('veiculoExterno.nomeMotorista', this.data_local.nomeMotoristaExterno);      
                params.append('veiculoExterno.ativo', true);

                params.append("nomeMotoristaExterno", this.data_local.nomeMotoristaExterno);
            }


            if (this.data_local.tipo === 'ENTRADA') {
                params.append('dataHoraEntrada', this.data_local.data + ' ' + this.data_local.hora + ":00");    
            } else {
                params.append('dataHoraSaida', this.data_local.data + ' ' + this.data_local.hora + ":00");    
            }

            if (this.data_local.odometroEmKMInformado) {  
                params.append('odometroEmKMInformado', this.data_local.odometroEmKMInformado);      
            }

            if (this.data_local.horimetroInformado) {  
                params.append('horimetroInformado', this.data_local.horimetroInformado);    
            }

            if (this.data_local.observacao) {
                params.append('observacao', this.data_local.observacao);    
            }

            if (this.data_local.motorista && this.data_local.motorista.id) {
                params.append("motorista.id", this.data_local.motorista.id);
            }  

            params.append("sairDaFilaEntrada", this.data_local.sairDaFilaEntrada);
            
            axios.post(URL_SERVLET+ "MobileInserir", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                    
                    this.$router.push({ path: '/controle-portaria' });                    
                } else {                    
                    if (response.data.Resultado.hasOwnProperty("error")) {
                            this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Resultado.error, acceptText: 'OK'})
                    } else {                        
                        this.limparCampos();
                        var agora = new Date();
                        this.data_local.data = agora.getFullYear() + "-" + generico.zeroPad((agora.getMonth() + 1), 2) + "-" + generico.zeroPad(agora.getDate(), 2);
                        this.data_local.hora = generico.zeroPad(agora.getHours(), 2) + ":" + generico.zeroPad(agora.getMinutes(), 2);
                        this.$vs.notify({
                                    time:8000, title: "Atenção",  text: "Registro efetuado com sucesso", iconPack: 'feather', icon: 'icon-alert-circle', color: 'success'
                        });
                        
                    }                   
                }

            })
            .catch((error) => { 
                /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }         
    },   
    sair() {
        this.$router.push({
            name: 'page-exit-controle-portaria'
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];

        if (!this.data_local.tipo ) {
            this.errorsValidacao.push("Informe se o registro é uma ENTRADA ou SAÍDA");
        }
        if (this.isNovoVeiculo) {
            if (!this.dadosVeiculo.marca) {
                this.errorsValidacao.push("Marca do veículo " + this.$t('Mensagem_Erro_Obrigatorio'));
            }
            if (!this.dadosVeiculo.modelo) {
                this.errorsValidacao.push("Modelo do veículo " + this.$t('Mensagem_Erro_Obrigatorio'));
            }
            if (!this.dadosVeiculo.cor) {
                this.errorsValidacao.push("Cor do veículo " + this.$t('Mensagem_Erro_Obrigatorio'));
            }
            if (!this.dadosVeiculo.placa) {
                this.errorsValidacao.push("Placa do veículo " + this.$t('Mensagem_Erro_Obrigatorio'));
            }
        } else {
            if (!this.data_local.veiculo.idVeiculo && !this.data_local.veiculoExterno.id) {
                this.errorsValidacao.push("Veículo " + this.$t('Mensagem_Erro_Obrigatorio'));
            }

            if (!this.data_local.motorista.id && !this.data_local.nomeMotoristaExterno) {
                this.errorsValidacao.push("Motorista " + this.$t('Mensagem_Erro_Obrigatorio'));
            }
        }

        if (!this.data_local.data ) {
            this.errorsValidacao.push("Data " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.data_local.hora ) {
            this.errorsValidacao.push("Hora " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.data_local.odometroEmKMInformado &&  !this.data_local.horimetroInformado ) {
            this.errorsValidacao.push("Odômetro " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.data_local.horimetroInformado && !this.data_local.odometroEmKMInformado) {
            this.errorsValidacao.push("Horímetro " + this.$t('Mensagem_Erro_Obrigatorio'));
        }

        if (!this.errorsValidacao.length) {
            return true;
        }   
      window.scrollTo(0, 0);  
      return false;
    },   
    routeHistorico() {
      this.$router.push({
            name: 'page-pesquisar-controle-portaria'                     
      })
    },         
  },
  created() {
    
  }
}
</script>

